import { Send } from 'lucide-react'

export function ChatRoomEmpty() {
	return (
		<div className="flex h-full flex-col items-center justify-center text-center">
			<div className="mb-4 rounded-full bg-muted p-6">
				<Send className="h-12 w-12 text-muted-foreground" />
			</div>
			<h3 className="mb-2 text-lg font-semibold">เลือกแชทเพื่อเริ่มสนทนา</h3>
			<p className="max-w-sm text-sm text-muted-foreground">
				เลือกห้องแชทจากรายการด้านซ้ายเพื่อดูและตอบข้อความจากลูกค้า
			</p>
		</div>
	)
}
